"use strict";

import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import { persistStore } from "redux-persist";
import ReactDOM from "react-dom/client";
import { configureStore, history } from "./_redux/_store";
import App from "./App";
import i18n from "./i18n";
import "./styles/styles.scss";

const store = configureStore({});
const persistor = persistStore(store);
const root = ReactDOM.createRoot(document.getElementById("app"));

const renderApp = (Component) => {
  root.render(<Component store={store} persistor={persistor} />);
};

renderApp(App);

if (module.hot) {
  module.hot.accept("./App", () => {
    renderApp(App);
  });
}
